<!-- ================:=========================================================================
  File Name: EditDomain.vue
  Description: User Edit Page

========================================================================================== -->

<template>
  <div id="course-new">

    <vx-card>

      <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Details" icon-pack="feather" icon="icon-edit">
            <div class="tab-text">
              <course-details-tab :data="courseData" v-on:update_courseData="courseDataUpdate" v-on:insert_courseData="createCourse"/>
            </div>
          </vs-tab>
        </vs-tabs>

      </div>

    </vx-card>
  </div>
</template>

<script>
import CourseDetailsTab     from './CourseDetailsTab.vue'

export default {
  components: {
    CourseDetailsTab
  },
  data () {
    return {
      courseData: {
        course_name: undefined,
        course_description: undefined,
        course_status: undefined,
        course_code: undefined,
        course_thumbnail: undefined,
        course_banner: undefined
      },

      module_data: null,

      activeTab: 0
    }
  },
  watch: {
    activeTab () {
    //tab change
    }
  },
  methods: {
    courseDataUpdate (data) {
      this.courseData = data
    },
    createCourse () {

      const pl = {
        name: this.courseData.course_name,
        description: this.courseData.course_description,
        status: this.courseData.course_status === undefined ? 'active' : this.courseData.course_status,
        code: this.courseData.course_code,
        thumbnail: this.courseData.course_thumbnail,
        banner: this.courseData.course_banner
      }

      if (pl.name === undefined) {
        return this.$vs.notify({
          title: 'Failed to create course',
          text: 'Please provide a Course Name',
          color: 'danger',
          position: 'top-right'
        })
      }

      if (pl.code === undefined) {
        return this.$vs.notify({
          title: 'Failed to create course',
          text: 'Please assign code to course',
          color: 'danger',
          position: 'top-right'
        })
      }

      this.$vs.loading()

      this.$http.post('courses/create', pl)
        .then(response => {
          this.$vs.loading.close()

          this.$vs.notify({
            title: 'Created course successfully',
            text: `New local course ${pl.name} has been created.`,
            color: 'success',
            position: 'top-right'
          })

          if (response.status === 200) {
            const data = response.data.data
            this.$router.push(`/a/courses/${data.id}`)
          }

        })
        .catch(exception => {

          let error = 'An unknown error occurred while creating this course'
          if (exception.response) {
            error = exception.response.data.error.description
          }

          return this.$vs.notify({
            title: 'Failed to create course',
            text: error,
            color: 'danger',
            position: 'top-right'
          })
        })
    }
  }
}

</script>
